
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesPromoEditor extends Common.GridEditorBase<ECommSalesPromoRow> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesPromo'; }
        protected getDialogType() { return ECommSalesPromoDialog; }
        protected getLocalTextPrefix() { return ECommSalesPromoRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        public getData(PromoDetails) {
            var tmp = [];
            for (let Detail of PromoDetails) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                var x = Detail;
                tmp.push(Detail);
            }
            return tmp;

        }
    }
}